// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"df0467d8","370":"fa694f40","867":"0089b21f"}[chunkId] + ".chunk.js";
};